import React from "react";

const JOURNEY_ITEMS = [
  {
    year: "2019",
    title: "Data Engineer – City National Bank",
    description:
      "Set up the Oracle BDA cluster and designed, built, deployed, and maintained end-to-end data pipelines on the Enterprise Data Lake.",
  },
  {
    year: "2020",
    title: "Coding for Kids – Community Impact",
    description:
      "Successfully conducted online 'Coding for Kids' classes during COVID, expanding into education and community impact.",
  },
  {
    year: "2021",
    title: "Kafka & Confluent Platform",
    description:
      "Deployed a secure Kafka Confluent Platform 7.1 cluster using Ansible automation and delivered data engineering solutions.",
  },
  {
    year: "2022",
    title: "CDH → CDP Upgrade with Cloudera",
    description:
      "Partnered with Cloudera to upgrade the platform from CDH 5.14.4 to CDP 7.1.7, improving data access for data science and engineering teams.",
  },
  {
    year: "2023",
    title: "Streaming Pipelines",
    description:
      "Implemented Kafka and Spark Streaming pipelines integrating S3, Spark, Kafka, and Solace source/sink connectors.",
  },

  /* ✅ 2024 – ALL IN ONE BOX */
  {
  year: "2024",
  title: "Web Development",
  description: (
    <>
      <p>
        <strong>React Web Application</strong><br />
        Developed a React-based web application implementing secure OpenAI integrations with Single Sign-On (SSO).
      </p>
       <p>
        <strong>Flask Web Application</strong><br />
        Built a Flask-based web application with Open AIs (Python, Flask,
        MySQL), using tools such as Notion, Promod, and World Time.
        
      </p>
      <p>
        <strong> Multi-vendor Digital Solutions</strong><br />
        Delivered multi-vendor digital solutions including WhatsApp Store,
        API integrations, e-commerce platforms, and social media setup.
      </p>
     
    </>
  ),
},
{
  year: "",
  title: "Accounts RPA",
  description: (
    <p>
      Implemented Accounts RPAs covering ERP login automation,
      Ready-to-Payout processing, automated email sharing,
      and disbursement workflows integrated with Marvel.
    </p>
  ),
},


  /* ✅ 2025 – BOX 1 */
  {
    year: "2025",
    title: "Digital Consultant – Content",
    description:
      "Produced 100+ social media videos to build brand awareness and education.",
  },

  /* ✅ 2025 – BOX 2 (Accounts + HR combined) */
  {
    year: "",
    title: "RPA Consultant – Accounts & HR",
    description: (
      <>
        <p>
          <strong>Accounts RPA:</strong> Course Validation,
          Disburse Validation, Credit Note Validation.
        </p>
        <p>
          <strong>HR RPA:</strong> Trainers’ Fee Calculation, Attendance Report,
          TRAQOM Survey Report.
        </p>
      </>
    ),
  },

  /* ✅ 2025 – BOX 3 (Cloudera Labs + E-Learning combined) */
  {
    year: "",
    title: "AI/Data Consultant – Cloudera Labs & E-Learning",
    description: (
      <>
        <p>
          Set up AWS-based Cloudera clusters and labs: Admin, Data Engineering,
          Data Analyst, CAI, and CML.
        </p>
        <p>
          Created an e-learning platform for the above Cloudera labs and content.
        </p>
      </>
    ),
  },
];


export default function JourneyTimeline() {
  return (
    <section className="timeline">
      <h2 className="timeline-heading">SiW Journey (2019–2025)</h2>
      <div className="timeline-list">
        {JOURNEY_ITEMS.map((item, index) => (
          <article className="timeline-item" key={`${item.year}-${index}`}>
            <div className="timeline-left">
              <span className="timeline-year" >{item.year}</span>
              <span className="timeline-dot" />
              {index !== JOURNEY_ITEMS.length - 1 && (
                <span className="timeline-line" />
              )}
            </div>
            <div className="timeline-card">
              <h3 className="timeline-title">{item.title}</h3>
              <p className="timeline-description">{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
